"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObjectFitSupported = exports.isIE = exports.isEdge = exports.isDesktop = void 0;
var _bowser = _interopRequireDefault(require("bowser"));
var _constant = _interopRequireDefault(require("lodash/constant"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 * Browser
 */

var bowser = _bowser["default"].getParser(window.navigator.userAgent);
var isDesktop = exports.isDesktop = (0, _constant["default"])(bowser.is('desktop'));
var isEdge = exports.isEdge = (0, _constant["default"])(bowser.is('edge'));
var isIE = exports.isIE = (0, _constant["default"])(bowser.is('ie'));

/*
 * Feature detection
 */

var isObjectFitSupported = exports.isObjectFitSupported = (0, _constant["default"])('objectFit' in document.documentElement.style);
//# sourceMappingURL=browser-utils.js.map